"use client";
import { BackNav, Panel } from "components";
import { useCounselingSubmit } from "hooks";
import { MoveType } from "models";
import { useState } from "react";
import { FormattedMessage, useIntl } from "services";
import { useOrder } from "store";
import { counselingStatusToPathMap, MoveTypeId } from "types";
import { CounselingLayout } from "./components";
import { CounselingButton } from "./components/CounselingButton";

export function MoveTypePage() {
  const { formatMessage } = useIntl();
  const order = useOrder();

  const [continueButtonActive, setContinueButtonActive] = useState(
    order.moveType.moveType !== null
  );

  const [selectedMoveType, setSelectedMoveType] = useState<MoveTypeId>(
    order.moveType.moveType
  );

  const { handleNext, loading } = useCounselingSubmit({
    nextStatus: "ADDRESSES_ORIGIN",
    saveCallback: async (moveType: MoveType) => {
      if (selectedMoveType && selectedMoveType === "FULL_SERVICE") {
        moveType.moveType = selectedMoveType;
      }
      return true;
    },
  });

  const clickMoveType = (selectedMoveType: MoveTypeId) => {
    setSelectedMoveType(selectedMoveType);
    setContinueButtonActive(true);
  };

  return (
    <CounselingLayout ariaLabel={"ariaLabels.counseling.moveType"}>
      {order.hasEntitlementsCounseling ? (
        <BackNav href={counselingStatusToPathMap.ENTITLEMENTS_FORMS} />
      ) : null}
      <CounselingLayout.Heading>
        <FormattedMessage id="counseling.moveType.title" />
      </CounselingLayout.Heading>
      <CounselingLayout.InfoText>
        <FormattedMessage id="counseling.moveType.instructions" />
      </CounselingLayout.InfoText>
      <Panel
        icon="boxes_and_lamp"
        title={<FormattedMessage id="counseling.moveType.fsm.title" />}
        ariaLabel={formatMessage({
          id: "ariaLabels.counseling.moveType.fsm",
        })}
        onClick={() => {
          clickMoveType("FULL_SERVICE");
        }}
        completed={selectedMoveType === "FULL_SERVICE"}
      >
        <FormattedMessage id="counseling.moveType.fsm.message" />
      </Panel>

      <CounselingButton
        disabled={!continueButtonActive}
        onClick={handleNext}
        isSubmitting={loading}
      />
    </CounselingLayout>
  );
}
